import { AxiosError, AxiosResponse } from "axios";

import type { ErrorHandler } from "./errorHandlers/errorHandler.types";

export function createResponseInterceptor(handlers: ErrorHandler[]) {
  return {
    onFulfilled: (response: AxiosResponse) => response,

    onRejected: (error: AxiosError) => {
      for (const handler of handlers) {
        const handled = handler(error);
        if (handled) break;
      }

      return Promise.reject(error);
    },
  };
}
